import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ReservationFamily } from './reservation-family.model';
import { ReservationFamilyService } from './reservation-family.service';
import { HttpErrorResponse } from '@angular/common/http';


@Injectable()
export class ReservationFamilyPopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private reservationFamilyService: ReservationFamilyService
    ) { }

    open(component: Component, id?: number | any, studentId?: number | any, lessonId?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.reservationFamilyService.find(id).subscribe(reservation => {
                this.reservationModalRef(component, reservation);
            }, (error: HttpErrorResponse) => {
                this.isOpen = false;
            });
        }
    }

    reservationModalRef(component: Component, reservationFamily: ReservationFamily): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.reservationFamily = reservationFamily;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-family/reservation-family-popup.service.ts